// JS weekday indexes: Sunday=0. Python uses Monday=0; do not send these
// indexes as Python weekdays. Missing store data retains the Monday default.
export const getBusinessWeekStartIndex = (dayName) => {
  const days = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
  const index = days.indexOf(String(dayName || "").trim().toLowerCase());
  return index === -1 ? 1 : index;
};

export const getBusinessWeekStartDayIndex = (stores, storeId) =>
  getBusinessWeekStartIndex((stores || []).find((store) => store.id === storeId)?.business_week_start_day);
